import { useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export const OfferJob = ({ partnerId, orders }) => {
  const [wo, setWo] = useState("");
  const [msg, setMsg] = useState("");
  const send = async () => {
    setMsg("Sending…");
    const r = await fetch(`${API}/api/admin/trade-network/roster/${partnerId}/offer`, {
      method: "POST", credentials: "include", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ work_order_id: wo }),
    });
    const j = await r.json().catch(() => ({}));
    setMsg(r.ok ? "Offer sent" : j.detail || "Could not send");
  };
  if (!orders.length) return <div className="rr-cell rr-muted" data-testid={`roster-offer-none-${partnerId}`}>No open work orders in this trade</div>;
  return (
    <div className="rr-offer" data-testid={`roster-offer-${partnerId}`}>
      <select value={wo} onChange={(e) => setWo(e.target.value)} data-testid={`roster-offer-select-${partnerId}`}>
        <option value="">Offer a work order…</option>
        {orders.map((o) => <option key={o.work_order_id} value={o.work_order_id}>{o.work_order_id} · {o.trade_label || o.trade_lane} · {o.property_address}</option>)}
      </select>
      <button type="button" disabled={!wo} onClick={send} data-testid={`roster-offer-send-${partnerId}`}>Send offer</button>
      {msg && <span data-testid={`roster-offer-msg-${partnerId}`}>{msg}</span>}
    </div>
  );
};
